<template>
  <v-form v-model="validate" lazy-validation>
    <div class="mobile-container">
      <div class="pb-05">
        <v-card rounded="0" class="mb-2 pa-4 pb-3 ev-0">
          <div class="col-12 pa-0">
            <v-text-field
              dense
              outlined
              required
              height="50"
              color="var(--logistic)"
              type="text"
              v-model="draft.short_name"
              label="نام کوتاه"
              :rules="[$utils.validators.required, $utils.validators.onlyFarsi]"
            ></v-text-field>
            <div class="font-xsmall medium-emp pr-4">
              مثلا شرکت، کارگاه و ...
            </div>
          </div>
        </v-card>
      </div>

      <div class="pb-05">
        <v-card rounded="0" class="py-4 ev-0">
          <div class="row mx-4 rounded-sides">
            <div
              v-for="option of options"
              :key="option.id"
              class="pa-0 col id-option"
            >
              <div
                @click="switchOption(option)"
                class="pa-3 border border-grey cursor-pointer"
                :class="option.active && 'active-option'"
                elevation="0"
              >
                <v-icon
                  v-if="option.active"
                  class="ml-2 logistic--text force-color"
                  >mdi-check-circle</v-icon
                >
                <v-icon v-else class="ml-2 grey--text"
                  >mdi-circle-outline</v-icon
                >
                <small class="bold" v-text="option.name"></small>
              </div>
            </div>
          </div>
        </v-card>
      </div>

      <v-card rounded="0" class="row mx-0 ev-0 mt-2 pt-1 pb-2">
        <div class="col-12 px-4 pb-0">
          <v-text-field
            :rules="[$utils.validators.required]"
            append-icon="mdi-chevron-left"
            @focus="cityDialog = true"
            :label="`شهر ${person}`"
            color="var(--logistic)"
            :value="
              selectedCity.city &&
              selectedCity.state + ' - ' + selectedCity.city
            "
            height="50"
            type="text"
            outlined
            required
            dense
          ></v-text-field>
        </div>
        <div
          v-for="(input, index) of inputs"
          :key="type + index"
          class="col-12 px-4 pb-0"
        >
          <v-text-field
            :rules="input.rule"
            v-model="draft[input.model]"
            color="var(--logistic)"
            :label="input.label"
            :type="input.type"
            height="50"
            clearable
            outlined
            required
            dense
          ></v-text-field>
        </div>
        <div class="col-12 px-4 pb-0">
          <v-textarea
            :rules="[$utils.validators.required, $utils.validators.notEnglish]"
            :label="`آدرس دقیق ${person}`"
            v-model="draft.address"
            color="var(--logistic)"
            height="50"
            outlined
            required
            dir="rtl"
            dense
          ></v-textarea>
        </div>
      </v-card>
    </div>
    <!-- Footer -->
    <v-card
      rounded="0"
      class="
        pa-2
        position-fixed
        bottom-0
        w-100
        border
        d-block
        z-5
        ev-0
        px-md-30
      "
    >
      <v-row class="mx-0">
        <v-col cols="6" class="px-2 py-0">
          <v-btn
            outlined
            class="
              white
              border-outline
              d-flex
              justify-center
              align-center
              logistic--text
              force-color
              rounded
              w-100
              py-6
            "
            @click="
              $router.push('/Panel/SelectedLoadsAddresses').catch(() => {})
            "
          >
            انصراف
          </v-btn>
        </v-col>
        <v-col cols="6" class="px-2 py-0">
          <v-btn
            @click="update()"
            :loading="loading"
            :disabled="!validate || checkSame"
            class="w-100 logistic-color white--text py-6"
            elevation="0"
          >
            به روز رسانی
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <city-select-list
      :visible="cityDialog"
      :currentValue="selectedCity"
      :title="person"
      @handle-place-dialog="handleCityDialog"
    ></city-select-list>
  </v-form>
</template>

<script>
import CitySelectList from "../components/CitySelectList.vue";

export default {
  components: { CitySelectList },
  props: {
    draft: {
      type: Object,
      require: true,
    },
    type: {
      type: String,
      require: true,
      default: "sender",
    },
  },
  watch: {
    draft: {
      deep: true,
      handler(val) {
        let baseDraft = JSON.stringify(this.baseDraft);
        let newDraft = JSON.stringify(val);

        if (baseDraft === newDraft) {
          this.checkSame = true;
        } else {
          this.checkSame = false;
        }
      },
    },
  },
  data() {
    return {
      cityDialog: false,
      validate: false,
      checkSame: true,
      selectedCity: {
        state: null,
        city: null,
      },
      options: [
        {
          name: "شخصیت حقیقی",
          id: 2,
          active: true,
        },
        {
          name: "شخصیت حقوقی",
          id: 1,
          active: false,
        },
      ],
      loading: false,
      baseDraft: null,
    };
  },
  mounted() {
    this.initOption();
    this.initCity();
    this.baseDraft = { ...this.draft };
  },
  methods: {
    async update() {
      this.loading = true;
      const url = "edit_draft_address_by_company";
      let draft = this.draft;

      draft.draft_id = this.draft.objectId;
      draft.companyId = localStorage.getItem("companyId");

      const res = await this.$parseSDK.Cloud.run(url, draft).catch((err) => {
        this.$utils.handleErrorIfKnown(err.message);
      });

      if (res) {
        this.$router.push("/Panel/SelectedLoadsAddresses").catch(() => {});
        this.$utils.showMessage("با موفقیت ویرایش شد", {
          type: "success",
        });
      }
      this.loading = false;
    },
    initOption() {
      if (!this.draft.type) return;

      const type_id = this.draft.type;
      const option = this.options.find((op) => +op.id == type_id);

      this.switchOption(option);
    },
    initCity() {
      if (!this.draft) return;

      const city_state = {
        state: this.draft.ostan,
        city: this.draft.city,
      };
      this.handleCityDialog(null, city_state);
    },
    switchOption(op) {
      this.options.map((option) => (option.active = false));
      this.draft.type = op.id;
      op.active = true;
    },
    handleCityDialog(op, data) {
      this.cityDialog = false;
      if (!data) {
        this.resetLocation();
        return;
      }
      this.selectedCity = data;
      this.fillPlace(data.city, data.state);
    },
    fillPlace(city = null, state = null) {
      this.draft.city = city;
      this.draft.ostan = state;
    },
    resetLocation() {
      this.selectedCity = {
        state: null,
        city: null,
      };
      this.fillPlace();
    },
  },
  computed: {
    person() {
      const type = this.type;
      return type == "receiver" ? "گیرنده" : "فرستنده";
    },
    nationalCode() {
      const type = this.options.find((option) => option.active == true);
      const mCode = {
        text: "کدملی ",
        length: 10,
      };
      const sCode = {
        text: "شناسه ملی ",
        length: 11,
      };
      return type.id == 2 ? mCode : sCode;
    },
    name() {
      const type = this.options.find((option) => option.active == true);
      return type.id == 2 ? "نام و نام خانوادگی " : "نام شخص / شرکت ";
    },
    inputs() {
      const inputs = [
        {
          label: this.name + this.person,
          model: "full_name",
          type: "text",
          rule: [
            this.$utils.validators.required,
            this.$utils.validators.onlyFarsi,
          ],
        },
        {
          label: this.nationalCode.text + this.person,
          model: "national_code",
          type: "number",
          rule: [
            this.$utils.validators.required,
            this.$utils.validators.onlyNumbers,
            this.$utils.validators.fixedLength(
              this.draft.national_code,
              this.nationalCode.length
            ),
          ],
        },
        {
          label: `شماره موبایل ${this.person}`,
          model: "phone",
          type: "tel",
          rule: [
            this.$utils.validators.required,
            this.$utils.validators.iranmobile,
            this.$utils.validators.onlyNumbers,
            this.$utils.validators.fixedLength(this.draft.phone, 11),
          ],
        },
        {
          label: `تلفن ثابت ${this.person} ( با کد شهر )`,
          model: "land_line",
          type: "tel",
          rule: [
            this.$utils.validators.required,
            this.$utils.validators.onlyNumbers,
            this.$utils.validators.fixedLength(this.draft.land_line, 11),
          ],
        },
        {
          label: `کدپستی ${this.person}`,
          model: "postal_code",
          type: "number",
          rule: [
            this.$utils.validators.onlyNumbers,
            this.$utils.validators.fixedLength(this.draft.postal_code, 10),
          ],
        },
      ];
      return inputs;
    },
  },
};
</script>

<style lang="scss" scoped>
.border-grey {
  border: 1px solid #b8b8b8;
  border-radius: 4px !important;
}
.rounded-sides .id-option {
  &:first-child .border {
    border-radius: 0 4px 4px 0 !important;
  }
  &:last-child .border {
    border-radius: 4px 0 0 4px !important;
  }
}
.border-outline {
  border: none;
  outline: 0.5px solid rgba(0, 0, 0, 0.12) !important;
}
@media (min-width: 960px) {
  .px-md-30 {
    padding-right: 25vw !important;
    padding-left: 25vw !important;
  }
}
</style>